'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSortByAlpha = function MdSortByAlpha(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.3 26.9h10.1v2.6h-14.2v-2.1l9.8-14.3h-9.7v-2.6h13.8v2.1z m-18-4.2h6.5l-3.3-8.6z m1.9-12.2h2.7l7.5 19h-3.1l-1.5-4h-8.5l-1.6 4h-3z m6.9 21.8h7.7l-3.9 3.9z m7.8-24.6h-7.9l3.9-3.9z' })
        )
    );
};

exports.default = MdSortByAlpha;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/sort-by-alpha.js
// module id = 2801
// module chunks = 0